"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _classnames = _interopRequireDefault(require("classnames"));
var _get = _interopRequireDefault(require("lodash/get"));
var FormErrorMessage = (0, _formik.connect)(function (props) {
  var formik = props.formik,
    name = props.name,
    _props$showAfterTouch = props.showAfterTouch,
    showAfterTouch = _props$showAfterTouch === void 0 ? true : _props$showAfterTouch;
  var touched = formik.touched,
    errors = formik.errors;
  var isTouched = showAfterTouch ? (0, _get["default"])(touched, name) : true;
  var errorMessage = (0, _get["default"])(errors, name);
  var showMessage = isTouched && errorMessage;
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('text-red text-xs', {
      invisible: !showMessage
    }, props.className)
  }, errorMessage ? errorMessage : 'No errors');
});
var _default = exports["default"] = FormErrorMessage;
//# sourceMappingURL=index.js.map